import React from "react";

/**
 * Componente para renderizar una línea de la terminal
 * Puede contener texto o un dropdown
 */
export const TerminalLine = ({ children, className = "" }) => {
  return (
    <div className={`terminal-line ${className}`}>
      {children}
    </div>
  );
};

export default TerminalLine;








